/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */


/**
 * Map types for GTM component
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.1.0
 */

import { EAccountType } from '../../../../pages/PageAuth/constants/authConstants';
import { EWidgetSubscriberMobile } from '../../../../pages/PageDashboard/components/Widgets/WidgetSubscriberMobile/widgetSubscriberMobileTypes';
import { EGTMAccountType } from '../GTMconstants';

export const mapAccountTypeToGTMAccountType: { [key: string]: EGTMAccountType } = {
    [EAccountType.CREDIT]: EGTMAccountType.CREDIT,
    [EAccountType.EMPTY]: EGTMAccountType.EMPTY,
    [EAccountType.PREPAID]: EGTMAccountType.PREPAID,
};


enum EGTMWidgetSubscriberMobileTab {
    labels = 'По меткам',
    tariffs = 'По тарифам'
}

export const mapWidgetSubscriberTabTypeToGTMTabType: {[key: string]: string } = {
    [EWidgetSubscriberMobile.LABELS]: EGTMWidgetSubscriberMobileTab.labels,
    [EWidgetSubscriberMobile.TARIFFS]: EGTMWidgetSubscriberMobileTab.tariffs,
};
